module.exports = __webpack_public_path__ + "img/select.d36797f5.svg";